import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderSlot as _renderSlot, isRef as _isRef, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import EInput from '@common/ui/EInput.vue';
import { ref, toRef, useSlots } from 'vue';
import { useField } from 'vee-validate';
export default /*#__PURE__*/ _defineComponent({
    __name: 'EInputField',
    props: {
        name: {},
        size: {},
        id: {},
        disabled: { type: Boolean },
        readonly: { type: Boolean },
        placeholder: {},
        theme: {},
        type: {},
        autocomplete: { type: Boolean },
        label: {},
        clearable: { type: Boolean },
        showWordLimit: { type: Boolean },
        tabindex: {},
        maxlength: {},
        keyFilter: { type: Function },
        inputCenter: { type: Boolean },
        mask: {},
        required: { type: Boolean },
        textBefore: {},
        textAfter: {},
        hideError: { type: Boolean },
        regexRule: {},
        plugins: {}
    },
    emits: ["clear", "change", "changeValid", "input", "inputValid", "click", "focus", "blur", "paste", "keyup", "keydown", "mouseenter", "mouseleave"],
    setup: function (__props, _a) {
        var __expose = _a.expose, __emit = _a.emit;
        var props = __props;
        var emit = __emit;
        var slots = useSlots();
        var eInputRef = ref();
        var name = toRef(props, 'name');
        var handleInput = function (e) {
            emit('input', e);
            // handleChangeField(e)
        };
        var handleChange = function (e) {
            emit('change', e);
            handleChangeField(e);
        };
        var handleBlur = function (e) {
            emit('blur', e);
            handleBlurField(e);
        };
        var _b = useField(name, undefined, {
            syncVModel: true,
        }), inputValue = _b.value, handleBlurField = _b.handleBlur, handleChangeField = _b.handleChange;
        var focus = function () {
            var _a;
            (_a = eInputRef.value) === null || _a === void 0 ? void 0 : _a.focus();
        };
        var blur = function () {
            var _a;
            (_a = eInputRef.value) === null || _a === void 0 ? void 0 : _a.blur();
        };
        __expose({
            focus: focus,
            blur: blur,
        });
        return function (_ctx, _cache) {
            return (_openBlock(), _createBlock(EInput, {
                id: _ctx.id,
                ref_key: "eInputRef",
                ref: eInputRef,
                modelValue: _unref(inputValue),
                "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) { return (_isRef(inputValue) ? (inputValue).value = $event : null); }),
                autocomplete: _ctx.autocomplete,
                clearable: _ctx.clearable,
                disabled: _ctx.disabled,
                "input-center": _ctx.inputCenter,
                "key-filter": _ctx.keyFilter,
                label: _ctx.label,
                mask: _ctx.mask,
                maxlength: _ctx.maxlength,
                name: name.value,
                placeholder: _ctx.placeholder,
                plugins: _ctx.plugins,
                readonly: _ctx.readonly,
                "regex-rule": _ctx.regexRule,
                required: _ctx.required,
                "show-word-limit": _ctx.showWordLimit,
                size: _ctx.size,
                tabindex: _ctx.tabindex,
                "text-after": _ctx.textAfter,
                "text-before": _ctx.textBefore,
                theme: _ctx.theme,
                type: _ctx.type,
                onBlur: handleBlur,
                onChange: handleChange,
                onChangeValid: _cache[1] || (_cache[1] = function ($event) { return (emit('changeValid', $event)); }),
                onClear: _cache[2] || (_cache[2] = function ($event) { return (emit('clear')); }),
                onClick: _cache[3] || (_cache[3] = function ($event) { return (emit('click', $event)); }),
                onFocus: _cache[4] || (_cache[4] = function ($event) { return (emit('focus', $event)); }),
                onInput: handleInput,
                onInputValid: _cache[5] || (_cache[5] = function ($event) { return (emit('inputValid', $event)); }),
                onKeydown: _cache[6] || (_cache[6] = function ($event) { return (emit('keydown', $event)); }),
                onKeyup: _cache[7] || (_cache[7] = function ($event) { return (emit('keyup', $event)); }),
                onMouseenter: _cache[8] || (_cache[8] = function ($event) { return (emit('mouseenter', $event)); }),
                onMouseleave: _cache[9] || (_cache[9] = function ($event) { return (emit('mouseleave', $event)); }),
                onPaste: _cache[10] || (_cache[10] = function ($event) { return (emit('paste', $event)); })
            }, _createSlots({ _: 2 }, [
                (_unref(slots).append)
                    ? {
                        name: "append",
                        fn: _withCtx(function () { return [
                            _renderSlot(_ctx.$slots, "append")
                        ]; }),
                        key: "0"
                    }
                    : undefined,
                (_unref(slots).prepend)
                    ? {
                        name: "prepend",
                        fn: _withCtx(function () { return [
                            _renderSlot(_ctx.$slots, "prepend")
                        ]; }),
                        key: "1"
                    }
                    : undefined,
                (_unref(slots).textAfter)
                    ? {
                        name: "textAfter",
                        fn: _withCtx(function () { return [
                            _renderSlot(_ctx.$slots, "textAfter")
                        ]; }),
                        key: "2"
                    }
                    : undefined,
                (_unref(slots).textBefore)
                    ? {
                        name: "textBefore",
                        fn: _withCtx(function () { return [
                            _renderSlot(_ctx.$slots, "textBefore")
                        ]; }),
                        key: "3"
                    }
                    : undefined
            ]), 1032, ["id", "modelValue", "autocomplete", "clearable", "disabled", "input-center", "key-filter", "label", "mask", "maxlength", "name", "placeholder", "plugins", "readonly", "regex-rule", "required", "show-word-limit", "size", "tabindex", "text-after", "text-before", "theme", "type"]));
        };
    }
});
